export default __webpack_public_path__ + "static/media/undraw-wallet-aym-5.93db233c.png";